export enum WithdrawalMethods {
	'Deposito en mi cuenta' = 1,
	'Retirar por sucursal' = 2,
	'Retirar en el momento' = 3,
}
